import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import PlazaValdes from '../assets/images/layout/plaza_y_valdes_editores.jpg'
import Dukos from '../assets/images/layout/durkos_logo.png'
import BalamTzibtah from '../assets/images/layout/balamtzibtah.png'

export default function Footer() {
  return (
    <footer className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col md={6}>
            <h5><Link to="/contact" style={{color: 'white', textDecoration: 'none'}}>Contáctanos</Link></h5>
          </Col>
          <Col md={6} className='social'>
            <h5>Síguenos</h5>
            <ul className='social-icons list-unstyled d-flex justify-content-end'>
              <li>
                <a href="https://www.instagram.com/valentinaytaquito/" target='_blank'><img src="https://www.diadelavida.com/images/layout/instagram.svg" alt="Instagram" /></a>
              </li>
              <li style={{display: 'none'}}>
                <a href="#"><img src="https://www.diadelavida.com/images/layout/facebook.svg" alt="Facebook" /></a>
              </li>
              <li style={{display: 'none'}}>
                <a href="#"><img src="https://www.diadelavida.com/images/layout/tiktok.svg" alt="Tiktok" /></a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row className='mt-5'>
          <Col md={6} className='logos d-flex justify-content-between align-items-center'>
            <Link to="#" target="_blank">
              <img src={PlazaValdes} alt="Plaza y Valdés Editores" />
            </Link>
            <Link to="#" target="_blank">
              <img src={Dukos} alt="Plaza y Valdés USA" />
            </Link>
            <Link to="https://www.balamtzibtah.com" target="_blank">
              <img src={BalamTzibtah} alt="Balam Tzibtah" />
            </Link>
          </Col>
          <Col md={6}>
            <p className="mb-0">&copy; {new Date().getFullYear()} Noche de Muertos Día de la Vida. Todos los textos, imágenes, personajes y demás contenido tiene derechos reservados.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}